import { Button, Flex, SparkleIcon, Typography } from '@iheartjane/reefer';

import styles from './wizardModal.module.css';

interface WizardWelcomeProps {
  onGetStarted: () => void;
}

export const WizardWelcome = ({ onGetStarted }: WizardWelcomeProps) => {
  return (
    <Flex
      alignItems="center"
      flexDirection="column"
      gap={24}
      grow={1}
      justifyContent="center"
      p={40}
      data-testid="wizard-welcome"
    >
      <SparkleIcon size="md" color="primary" />
      <Typography variant="h2-semibold" as="p" textAlign="center">
        Let&rsquo;s find the right products, fast.
      </Typography>
      <Typography
        as="p"
        textAlign="center"
        className={styles['welcomeDescription']}
      >
        Answer 5 quick questions and we&rsquo;ll narrow it down to a short list
        of in-stock matches based on what you choose and what shoppers love.
      </Typography>
      <Button
        variant="primary"
        label="Get started"
        onClick={onGetStarted}
        className={styles['getStartedButton']}
      />
    </Flex>
  );
};
